'use strict';
import $ from 'jquery';
import uniq from 'lodash/uniq';
import pick from 'lodash/pick';

/**
 * Simple setter and getter for user filter preferences (gender select).
 * Save choice to session storage.
 *
 * @var {Object}
 */
export const preferences = (() => {
	let _preferences = null;
	const STORAGE_KEY = 'filterPreferences';

	return {
		STORAGE_KEY,

		get(forceRefresh = false) {
			if (window.sessionStorage && (!_preferences || forceRefresh)) {
				try {
					_preferences = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
				} catch (e) {
					console.log(e);
				}
			}
			return _preferences;
		},
		set(data) {
			if (window.sessionStorage) {
				_preferences = data;
				try {
					sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
				} catch (e) {
					console.log(e);
				}
			}
		}
	}
})();

export function init(mapping) {
	if (window.localStorage && window.sessionStorage) {
		try {
			$(window).bind('storage', transferSessionStorage);
			$(window).bind('receiveStorage', e => setTimeout(doStuff, 10));

			if (!sessionStorage.getItem(preferences.STORAGE_KEY)) {
				// Ask other tabs for session storage (this is only to trigger event)
				localStorage.setItem('getSessionStorage', Date.now());
			} else {
				doStuff();
			}
		} catch (e) {
			console.log(e);
		}
	}

	function doStuff() {
		const filters = preferences.get();
		if (filters.genders && filters.genders.length) {
			updateNavigationLinks();
		}
	}
}

/**
 * Transfer sessionStorage from one tab to another.
 */
function transferSessionStorage(e, storageKeys) {
	if (!e) e = window.event; // ie
	if (!e.newValue && e.originalEvent) e = e.originalEvent;
	if (!e.newValue) return; // do nothing if no value to work with

	// transfer only specific keys
	const keys = storageKeys || [preferences.STORAGE_KEY];

	if (e.key === 'getSessionStorage') {
		// Another tab asked for the sessionStorage -> send it
		const data = pick(sessionStorage, keys);
		if (data) {
			localStorage.setItem('sessionStorage', JSON.stringify(data));
			// The other tab should now have it, so we're done with it.
			localStorage.removeItem('sessionStorage');
		}
	}
	else if (e.key === 'sessionStorage') {
		// Another tab sent data <- get it
		const data = JSON.parse(e.newValue);
		$.each(data, (key, val) => sessionStorage.setItem(key, val));
		$(window).trigger('receiveStorage');
	}
}

/**
 * Update navigation link URLs to reflect users's currently selected filters.
 *
 * @return {Promise}
 */
export function updateNavigationLinks() {
	const filters = preferences.get();
	const $links = getVisibleLinks($('a.static-category'));
	const pageIds = $.map($links, item => $(item).data('page-id'));
	const pageIdsString = uniq(pageIds).join(',');
	const data = {filters, pageIds: pageIdsString};

	if (pageIds.length > 200) {
		return;
	}

	return $.getJSON('/stage-ajax/staticCategoryLinks', data)
		.then(res => {
			if (res && res.links) {
				$.each(res.links, (pageId, href) => {
					$(`a.static-category[data-page-id="${pageId}"]`).attr('href', href);
				});
			}
		});
}

/**
 * Filter a collection of navigation links to include currently visible links.
 *
 * @param  {jQuery} $links
 * @return {jQuery}
 */
function getVisibleLinks($links) {
	const isMobile = $(window).width() <= 768;

	return $.grep($links, (link) => {
		const $link = $(link);
		if (!$link.data('page-id')) return false;

		const isMobileLink = $link.closest('.mobile-nav').length > 0;
		if (isMobileLink && !isMobile) return false;

		const isLeftNavLink = $link.closest('.navigation-left').length > 0;
		if (isLeftNavLink && isMobile) return false;

		if (isLeftNavLink) {
			if ($link.closest('ul').hasClass('level-1')) return true; // top level link
			if (!$link.closest('.selected').length) return false;
		}
		return true;
	});
}

